import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileMedia = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.5 9.25C10.5 11.0449 9.04493 12.5 7.25 12.5C5.45507 12.5 4 11.0449 4 9.25C4 7.45507 5.45507 6 7.25 6C9.04493 6 10.5 7.45507 10.5 9.25ZM9 9.25C9 10.2165 8.2165 11 7.25 11C6.2835 11 5.5 10.2165 5.5 9.25C5.5 8.2835 6.2835 7.5 7.25 7.5C8.2165 7.5 9 8.2835 9 9.25Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21.75 21.5C22.7165 21.5 23.5 20.7165 23.5 19.75V4.25C23.5 3.2835 22.7165 2.5 21.75 2.5H2.25C1.2835 2.5 0.5 3.2835 0.5 4.25V19.75C0.5 20.7165 1.2835 21.5 2.25 21.5H21.75ZM2.25 4C2.11193 4 2 4.11193 2 4.25V19.75C2 19.8881 2.11193 20 2.25 20H5.42803L13.9996 10.9773C14.6774 10.2638 15.81 10.2493 16.5058 10.9452L22 16.4393V4.25C22 4.11193 21.8881 4 21.75 4H2.25ZM22 19.75V18.5607L15.4451 12.0058C15.3457 11.9064 15.1839 11.9085 15.0871 12.0104L7.497 20H21.75C21.8881 20 22 19.8881 22 19.75Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgFileMedia;
